import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Attribution } from "../components/Attribution";
import api from "../lib/api";

export default function Archive() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/chair-of-the-day/archive", { params: { days: 21 } }).then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 pt-10">
      <p className="overline text-accent">Chair of the Day</p>
      <h1 className="serif text-4xl sm:text-5xl lg:text-6xl tracking-tight mt-1 mb-10">The Archive</h1>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-5 gap-y-10">
        {items.map(({ date, chair }, i) => (
          <div key={date} className="reveal" style={{ animationDelay: `${Math.min(i * 60, 480)}ms` }} data-testid={`archive-item-${date}`}>
            <Link to={`/chair/${chair.slug}`} className="group block">
              <p className="overline mb-2">{new Date(date).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" })}</p>
              <div className="hover-zoom border border-border bg-card aspect-[4/3]">
                <img src={chair.image_url} alt={chair.title} loading="lazy" className="w-full h-full object-cover" />
              </div>
              <h3 className="serif text-xl mt-2 group-hover:text-accent transition-colors">{chair.title}</h3>
              <p className="text-sm text-muted-foreground">{chair.designer} · {chair.year}</p>
            </Link>
            <Attribution chair={chair} className="mt-1" />
          </div>
        ))}
      </div>
    </div>
  );
}
